import { GetterTree } from "vuex";
import { IPropertyEditState } from "../property-states.store";
// import { itemStateConstant } from "../../../../common";

const pictureGetters: GetterTree<IPropertyEditState, {}> = <GetterTree<IPropertyEditState, {}>>{
    service: (state: IPropertyEditState) => state.service,
    listOfPropertyPictures: (state: IPropertyEditState) => {
        // const sortedItems = [...state.property.Pictures].filter(c=>c.ItemState != itemStateConstant.Deleted).sort((a, b) => {return a.PictureNumber - b.PictureNumber});
        return state.property.Pictures || [];
    },
    listOfEvolutionPictures: (state: IPropertyEditState) => {
        // const sortedItems = [...state.property.ProjectEvolutionPictures].filter(c=>c.ItemState != itemStateConstant.Deleted).sort((a, b) => {return a.PictureNumber - b.PictureNumber});
        return state.property.ProjectEvolutionPictures || [];
    },

    listOfEnvironmentPictures: (state: IPropertyEditState) => {
        // const sortedItems = [...state.property.ProjectEnvironmentPictures].filter(c=>c.ItemState != itemStateConstant.Deleted).sort((a, b) => {return a.PictureNumber - b.PictureNumber});
        return state.property.ProjectEnvironmentPictures || [];
    },

    listOfProjectFeatures:(state:IPropertyEditState)=>
    {
        return state.property.ProjectFeatures;
    },

    listOfLinkedUnits:(state:IPropertyEditState)=>
    {
        return state.property.LinkedUnits;
    },
    
    propertyPicture: (state: IPropertyEditState)  => (id) => {
        const item = [...state.property.Pictures].find((c) => c.Id === id);
        return item;
    }
}

export default pictureGetters;